import { render, staticRenderFns } from "./Alexion.vue?vue&type=template&id=74a1e740&"
import script from "./Alexion.vue?vue&type=script&lang=js&"
export * from "./Alexion.vue?vue&type=script&lang=js&"
import style0 from "./Alexion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports